module.exports = __webpack_public_path__ + "static/img/janghyung-labor-management.f220a48.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/janghyung-labor-management.jpg
// module id = EfIw
// module chunks = 0